import WeEditionIqos3Duo from './WeEditionIqos3Duo';
export default WeEditionIqos3Duo;
